<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="编号">
              <a-input placeholder="" v-model="queryParam.clientId"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="密钥">
              <a-input placeholder="" v-model="queryParam.clientSecret"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-button @click="() => {this.queryPage()}" type="primary">查询</a-button>
            <a-button @click="() => queryParam = {}" style="margin-left: 8px">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
      <a-button @click="$refs.clientAddOrUpdate.init('','add')" icon="plus" type="primary" v-action="'sys:client:save'">新建</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1"><a-icon type="delete" />删除</a-menu-item>
          <!-- lock | unlock -->
          <a-menu-item key="2"><a-icon type="lock" />锁定</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>
    <s-table
      bordered
      ref="table"
      :alert="alert"
      :data="loadData"
      :columns="columns"
      :rowKey="record => record.clientId"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="action" slot-scope="text, record">
        <span v-action="'sys:client:update'">
          <a @click="edit(record)">修改</a>
          <a-divider type="vertical" />
        </span>
        <span v-action="'sys:client:del'">
          <a-popconfirm title="是否删除字典" @confirm="del(record)" okText="是" cancelText="否">
            <a-icon slot="icon" type="question-circle-o" style="color: red" />
            <a href="javascript:;" style="color: red">删除</a>
          </a-popconfirm>
        </span>
        <span v-action="'sys:client:info'">
          <a-divider type="vertical" />
          <a @lick="show(record)">查看</a>
        </span>
      </span>
    </s-table>
    <client-add-or-update
      @ok="queryPage"
      ref="clientAddOrUpdate"
    ></client-add-or-update>
  </a-card>
</template>

<script>
import { fetchList, delObj } from '@api/sys/client'
import ClientAddOrUpdate from './clientAddOrUpdate'
import { TableMixin } from '@/mixins/TableMixin'
export default {
  name: 'Client',
  mixins: [TableMixin],
  components: {
    ClientAddOrUpdate
  },
  data () {
    return {
      columns: [
        {
          title: 'id',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '编号',
          dataIndex: 'clientId'
        },
        {
          title: '密钥',
          dataIndex: 'clientSecret'
        },
        {
          title: '域',
          dataIndex: 'scope'
        },
        {
          title: '授权方式',
          dataIndex: 'authorizedGrantTypes'
        },
        {
          title: '令牌时效',
          dataIndex: 'accessTokenValidity'
        },
        {
          title: '刷新时效',
          dataIndex: 'refreshTokenValidity'
        },
        {
          title: '自动放行',
          dataIndex: 'autoapprove',
          customRender: (text) => (text ? '是' : '否')
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' }
        }
      ],
      queryParam: {
        clientId: '',
        clientSecret: ''
      },
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      }
    }
  },
  methods: {
    edit (record) {
      this.$refs.clientAddOrUpdate.init(record.clientId, 'edit')
    },
    del (record) {
      delObj(record.clientId).then(res => {
        this.$message.info('删除成功')
        this.queryPage()
      })
    },
    show (record) {
      this.$refs.clientAddOrUpdate.init(record.clientId, 'show')
    }
  }
}
</script>

<style scoped>

</style>
